import axios from 'axios'
import api from './axios'

// Use same env var as the authenticated axios instance
const API_BASE = import.meta.env.VITE_API_URL || '/api'

// Raw axios for public endpoints (no JWT interceptor, no response unwrapping)
const publicApi = axios.create({
    baseURL: API_BASE,
    timeout: 15000,
    headers: { 'Accept': 'application/json' },
})

/**
 * Chat API - Public endpoints (visitor)
 */
export const chatPublicApi = {
    getConfig: async (formId) => {
        const res = await publicApi.get(`/chat/config/${formId}`)
        return res.data // {success, data, message}
    },

    startConversation: async (data) => {
        const res = await publicApi.post('/chat/conversations', data)
        return res.data
    },

    getMessages: async (conversationId, visitorIdentifier) => {
        const res = await publicApi.get(`/chat/conversations/${conversationId}/messages`, {
            params: { visitor_identifier: visitorIdentifier }
        })
        return res.data
    },

    sendMessage: async (conversationId, visitorIdentifier, message) => {
        const res = await publicApi.post(`/chat/conversations/${conversationId}/messages`, {
            visitor_identifier: visitorIdentifier,
            message
        })
        return res.data
    },

    uploadFile: async (conversationId, visitorIdentifier, file, caption = '') => {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('visitor_identifier', visitorIdentifier)
        if (caption) formData.append('caption', caption)
        const res = await publicApi.post(`/chat/conversations/${conversationId}/upload`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 30000,
        })
        return res.data
    },
}

/**
 * Chat API - Agent endpoints (authenticated)
 */
export const chatAgentApi = {
    getConversations: async (formId, status = 'all', page = 1, perPage = 20) => {
        const response = await api.get('/chat/agent/conversations', {
            params: { form_id: formId, status, page, per_page: perPage }
        })
        return response
    },

    getMessages: async (conversationId, after = null) => {
        const params = {}
        if (after) params.after = after
        const response = await api.get(`/chat/agent/conversations/${conversationId}/messages`, { params })
        return response
    },

    sendMessage: async (conversationId, message) => {
        const response = await api.post(`/chat/agent/conversations/${conversationId}/messages`, { message })
        return response
    },

    editMessage: async (conversationId, messageId, message) => {
        const response = await api.put(`/chat/agent/conversations/${conversationId}/messages/${messageId}`, { message })
        return response
    },

    closeConversation: async (conversationId, notes = null) => {
        const response = await api.put(`/chat/agent/conversations/${conversationId}/close`, { notes })
        return response
    },

    getConversationStats: async (conversationId) => {
        const response = await api.get(`/chat/agent/conversations/${conversationId}/stats`)
        return response
    },

    saveAsSubmission: async (conversationId) => {
        const response = await api.post(`/chat/agent/conversations/${conversationId}/save-as-submission`)
        return response
    },

    getUnreadCount: async () => {
        const response = await api.get('/chat/unread-count')
        return response
    },
}

export default { chatPublicApi, chatAgentApi }
